import fetch from './fetch'

export default {
  getUsersMemberships (payload) {
    let request = fetch({
      url: `/usermember`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  createUserMembership (payload) {
    let request = fetch({
      url: `/usermember`,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  updateUserMembership (payload) {
    const { id, data } = payload
    let request = fetch({
      url: `/usermember/` + id,
      method: 'patch',
      data: data
    })
    return request.call()
  },
  deleteUserMembership (payload) {
    const id = payload.id
    let request = fetch({
      url: `/usermember/` + id,
      method: 'delete'
    })
    return request.call()
  },
  getLicenseUsed (payload) {
    let request = fetch({
      url: `/usermember/getLicenseUsed`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getLicenseAuth (payload) {
    let request = fetch({
      url: `/usermember/getLicenseAuth`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  }
}



// WEBPACK FOOTER //
// ./src/api/usermember.js